import { EXTERNAL_MENTION_ENTITY_TYPE } from './types';
import MentionComponent from './mentionComponent';
export var typeMapper = function () {
    var _a;
    return (_a = {},
        _a[EXTERNAL_MENTION_ENTITY_TYPE] = {
            component: MentionComponent,
            elementType: 'inline',
        },
        _a);
};
//# sourceMappingURL=typeMapper.js.map